import { render, staticRenderFns } from "./ArticleDetails.vue?vue&type=template&id=4b271a5c&scoped=true"
import script from "./ArticleDetails.vue?vue&type=script&lang=js"
export * from "./ArticleDetails.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetails.vue?vue&type=style&index=0&id=4b271a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b271a5c",
  null
  
)

export default component.exports